import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../translations';

interface LanguageProviderProps {
  children: React.ReactNode;
}

// Get direction based on language - handles regional codes
// RTL languages: Hebrew (he), Arabic (ar)
const getDirection = (language: string | undefined): 'ltr' | 'rtl' => {
  const rtlLanguages = ['he', 'ar'];
  return rtlLanguages.some(lang => language?.startsWith(lang)) ? 'rtl' : 'ltr';
};

/**
 * LanguageProvider - Wraps the app with i18n support
 *
 * Responsibilities:
 * - Initialize i18n on mount
 * - Sync document lang and dir attributes
 */
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();

  // Sync document direction with language
  useEffect(() => {
    const direction = getDirection(i18n.language);
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = direction;
  }, [i18n.language]);

  return <>{children}</>;
};

export default LanguageProvider;
